<template>
  
  <div style="width:98%;margin:0 auto">

          <iframe :src="getUrl" style="width:100%;height:800px;"></iframe>
             
        
        
      
          
  </div>
</template>
<script>

  export default{
    props:{
      //接收父组件传来的id值
      info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
       layerid:{
        type:String,
        default:""
      },
    
    },
   
         
      data(){
        return{
             id:'',
             getUrl:''

        
           
          
        }
      },
      created() {
       this.getUrl = 'https://wang.bd7080.com/jin/admin_race_in_pub.asp?race_jang='+this.info.id;
    },
    
      methods:{
        


      }
  }
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/common/race-dialog.vue